import type {
  NotificationChannel,
  NotificationLogResponse,
  PaginatedResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListNotificationLogsParams {
  readonly channel?: NotificationChannel | undefined;
  readonly limit?: number | undefined;
}

export const notificationsApi = {
  list(params: ListNotificationLogsParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<NotificationLogResponse>>('/notifications', {
      query: { ...params },
      signal,
    });
  },
};
